import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal } from 'hljd'
import LiveSpread from '../LiveSpread'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import Store from './store'
import Style from './style.module.less'

let bannerColor
const onValuesChange = async (_, values) => {
  if (Object.keys(values).includes('extensionBanner')) {
    let url = values.extensionBanner
    if (!url) {
      bannerColor = undefined
      return
    }
    if (url.includes('?')) {
      url = url + '&imageView2/2/h/160%7CimageAve'
    } else {
      url = url + '?imageView2/2/h/160%7CimageAve'
    }
    bannerColor = await fetch(url)
      .then(response => response.json())
      .then(res => res.RGB)
  }
}

@Form.create({
  name: 'spreadModalForm',
  onValuesChange
})
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(this.props.form)
    this.state = {
      getLivePopInfo: this.store.getLivePopInfo,
      visible: false
    }
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    const {
      current: { id, start_time },
      visible
    } = nextProps
    if (visible && !prevState.visible) {
      prevState.getLivePopInfo(id, start_time)
    }
    return {
      visible
    }
  }

  onCancel = () => {
    const { onCancel } = this.props
    onCancel && onCancel()
  }

  onOk = () => {
    const {
      form: { validateFields },
      onOk
    } = this.props
    validateFields(async (err, values) => {
      if (!err) {
        const params = {
          id: this.props.current.id,
          live_type: values.liveType
            ? values.liveType
            : this.store.live_info.liveType,
          pop_time: values.popTime,
          extension_banner: values.extensionBanner,
          banner_color: values.extensionBanner ? bannerColor : undefined
        }
        this.store.setLivePopTime(params, onOk)
      }
    })
  }

  render() {
    const { visible } = this.state
    const {
      onCancel,
      onOk,
      store: { live_info }
    } = this
    const { form, current } = this.props

    return (
      <Modal
        title={
          <div>
            <span style={{ fontSize: 16, color: '#333', fontWeight: 'bold' }}>
              推广直播
            </span>
            <span style={{ marginLeft: 10, color: '#999', fontSize: 12 }}>
              大幅度提高直播曝光，为直播引入更多流量同时宣传店铺品牌
            </span>
          </div>
        }
        width={680}
        visible={visible}
        onCancel={onCancel}
        onOk={onOk}
        className={Style.modal}
      >
        <LiveSpread
          form={form}
          type="modal"
          liveInfo={toJS(live_info)}
          fromType={current.fromType}
        />
      </Modal>
    )
  }
}
